import {Shift} from '@domain/shifthandover'
import {FilterDatePicker} from '@hconnect/common/components/dateTimeAndShift/FilterDatePicker'
import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {Done as DoneIcon} from '@mui/icons-material'
import {Box, Button} from '@mui/material'
import {FilterOptions} from '@widgets/shift-event-filters'
import {Moment} from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export type PerformanceFilterOptions = Pick<FilterOptions, 'timeRange'>

type PerformanceFilterProps = {
  settings: PerformanceFilterOptions
  onChange: (filterOptions: PerformanceFilterOptions) => void
  isCollapsible: boolean
  applyFilter: (filter: PerformanceFilterOptions) => void
  shifts: Shift[]
  timezone: string
  plantNow: Moment
}

export function PerformanceFilter({
  settings,
  onChange,
  isCollapsible,
  applyFilter,
  shifts,
  timezone,
  plantNow
}: PerformanceFilterProps) {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)

  const handleTimeRangeChange = (value: ShiftQuickSelectSlots | DateRange) => {
    const next = {...settings, timeRange: value}
    if (isCollapsible) {
      onChange(next)
    } else {
      applyFilter(next)
    }
  }

  return (
    <Box
      data-test-id={'performance-filter-options'}
      display={'flex'}
      sx={
        isCollapsible
          ? {
              flexDirection: 'column',
              paddingTop: '30px'
            }
          : {
              flexWrap: 'wrap',
              alignItems: 'center'
            }
      }
    >
      <FilterDatePicker
        onChange={handleTimeRangeChange}
        value={settings.timeRange}
        shifts={shifts}
        timezone={timezone}
        plantNow={plantNow}
        language={language}
        translate={t}
        defaultTimeRange="currentShift"
      />

      {isCollapsible && (
        <Box m={1}>
          <Button
            fullWidth
            data-test-id={'performance-apply-filter'}
            onClick={() => applyFilter(settings)}
            variant="contained"
            color="primary"
            startIcon={<DoneIcon />}
          >
            {t('shiftEvent.label.applyFilter')}
          </Button>
        </Box>
      )}
    </Box>
  )
}
